/* eslint-disable */
const AppRoutes = {
  PROFILE_ROUTE: '/profile/profileInfo/:username',
  CART: '/cart/',
  THANK_YOU: '/thank-you/:orderId',
  //? CBT ROUTE START HERE
  CFA1_2024_CBT: '/cfa1/2026/cbt',
  CFA1_2024_CBT_VIEW_ATTEMPTED_MOCK: '/cfa1/2026/viewattemptedmock/:id/:timer',
  CFA1_2024_CBT_INTRODUCTION: '/cfa1/2026/introduction/:id/:questiono/:timer',
  CFA1_2024_CBT_QUESTIONS:
    '/cfa1/2026/cbtquestions/:id/:questiono/:timer/:testid/:offset/:isNegative/:timerStart',
  CFA1_2024_CBT_QUESTION_FINISH:
    '/cfa1/2026/cbtquestionsfinish/:id/:questiono/:timer/:testid/:offset',
  CFA1_2024_DETAILED_RESULT_GRAPH: '/cfa1/2026/cbtshowresult/:id/:test_id/:totalQuestions/:timer',
  //* -=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=> ~~{{ CFA-I (2024) EXAM ROUTE ENDED HERE }}~~ <=-<=-<=-<=-<=-<=-<=-<=-<=-<=-<=-<=-<=-*//

  CFA1_2025_NOTES: '/cfa1/2026/notes',
  CFA1_2025_NOTES_READING_LIST: '/cfa1/2026/notes/chapter/:chapterId/reading-list',
  CFA1_2025_NOTES_VIEW: '/cfa1/2026/notes/chapter/:chapterId/reading/:readingId/notes/:notesId/view',
  CFA1_2025_NOTES_LIST: '/cfa1/2026/notes/chapter/:chapterId/reading/:readingId/notes-list',

  //? QUIZ ROUTE START HERE
  CFA1_2025_QUIZZES: '/cfa1/2026/quizzes',
  CFA1_2025_QUIZ_BEFORE_START: '/cfa1/2026/beforestart(/:quiz_id)(/:status_send)',
  CFA1_2025_QUIZ_BEGIN: '/cfa1/2026/beginquiz(/:quiz_id)(/:offset)',
  //* -=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=> ~~{{ CFA-I (2025) EXAM ROUTE ENDED HERE }}~~ <=-<=-<=-<=-<=-<=-<=-<=-<=-<=-<=-<=-<=-*//
  CFA1_2025_DASHBOARD: '/cfa1/2026/dashboard',
  CFA1_2025_DASHBOARD_VIEW_QUESTIONS: '/cfa1/2026/viewallquestions',

  CFA1_VIDEOS: '/cfa1/2026/videos',
  CFA1_VIDEO_LIST: '/cfa1/2026/video/chapterId/:chapterId/list/:id',
  CFA1_2025_NOTES_READING_LIST: '/cfa1/2026/notes/chapter/:chapterId/reading-list',
  CFA1_2025_QUESTION_BANK: '/cfa1/2026/question-bank',
  CFA1_2025_QUESTION_BANK_READING_LIST: '/cfa1/2026/question-bank/chapter/:chapterId/reading-list',
  CFA1_2025_QUESTIONS_LIST: '/cfa1/2026/question-bank/reading/:readingId/question-list',
  CFA1_2025_QUESTION_VIEW: '/cfa1/2026/question-bank/reading/:readingId/question/:questionId/view',

  //* -=> ~~{{ CFA-I 2027 — year-free /cfa1/2027/... tree (unique + deep-linkable; landing here
  //*        forces cfa_2027 via the #292 guard, see common/examUrlResolver.js). Mirrors the CFA1
  //*        route shapes 1:1 and reuses the CFA1-2025 view components. 2026 routes untouched. }}~~
  CFA1_2027_NEXT_DASHBOARD: '/cfa1/2027/dashboard',
  CFA1_2027_NEXT_DASHBOARD_VIEW_QUESTIONS: '/cfa1/2027/viewallquestions',
  CFA1_2027_NEXT_NOTES: '/cfa1/2027/notes',
  CFA1_2027_NEXT_NOTES_READING_LIST: '/cfa1/2027/notes/chapter/:chapterId/reading-list',
  CFA1_2027_NEXT_NOTES_VIEW:
    '/cfa1/2027/notes/chapter/:chapterId/reading/:readingId/notes/:notesId/view',
  CFA1_2027_NEXT_NOTES_LIST:
    '/cfa1/2027/notes/chapter/:chapterId/reading/:readingId/notes-list',
  CFA1_2027_NEXT_VIDEOS: '/cfa1/2027/videos',
  CFA1_2027_NEXT_VIDEO_LIST: '/cfa1/2027/video/chapterId/:chapterId/list/:id',
  CFA1_2027_NEXT_QUESTION_BANK: '/cfa1/2027/question-bank',
  CFA1_2027_NEXT_QUESTION_BANK_READING_LIST:
    '/cfa1/2027/question-bank/chapter/:chapterId/reading-list',
  CFA1_2027_NEXT_QUESTIONS_LIST: '/cfa1/2027/question-bank/reading/:readingId/question-list',
  CFA1_2027_NEXT_QUESTION_VIEW:
    '/cfa1/2027/question-bank/reading/:readingId/question/:questionId/view',
  CFA1_2027_NEXT_QUIZZES: '/cfa1/2027/quizzes',
  CFA1_2027_NEXT_QUIZ_BEFORE_START: '/cfa1/2027/beforestart(/:quiz_id)(/:status_send)',
  CFA1_2027_NEXT_QUIZ_BEGIN: '/cfa1/2027/beginquiz(/:quiz_id)(/:offset)',
  CFA1_2027_NEXT_CBT: '/cfa1/2027/cbt',
  CFA1_2027_NEXT_CBT_VIEW_ATTEMPTED_MOCK: '/cfa1/2027/viewattemptedmock/:id/:timer',
  CFA1_2027_NEXT_CBT_INTRODUCTION: '/cfa1/2027/introduction/:id/:questiono/:timer',
  CFA1_2027_NEXT_CBT_QUESTIONS:
    '/cfa1/2027/cbtquestions/:id/:questiono/:timer/:testid/:offset/:isNegative/:timerStart',
  CFA1_2027_NEXT_CBT_QUESTION_FINISH:
    '/cfa1/2027/cbtquestionsfinish/:id/:questiono/:timer/:testid/:offset',
  CFA1_2027_NEXT_DETAILED_RESULT_GRAPH:
    '/cfa1/2027/cbtshowresult/:id/:test_id/:totalQuestions/:timer',

  //? CBT ROUTE START HERE
  CFA2_CBT: '/cfa2/2026/cbt',
  CFA2_CBT_INTRODUCTION: '/cfa2/2026/introduction/:id/:questiono/:timer',
  CFA2_CBT_VIEW_ATTEMPTED_MOCK: '/cfa2/2026/viewattemptedmock/:id/:timer',
  CFA2_CBT_QUESTIONS:
    '/cfa2/2026/cbtquestions/:id/:caseno/:questiono/:timer/:testid/:caseOffset/:quesOffset/:isNegative/:timerStart',
  CFA2_CBT_QUESTIONS_FINISH:
    '/cfa2/2026/cbtquestionsfinish/:id/:caseno/:questiono/:testid/:caseOffset/:quesOffset/:timer',
  CFA2_DETAILED_RESULT_GRAPH: '/cfa2/2026/cbtshowresult/:id/:test_id/:totalQuestions/:timer/:isNegative',
  //* -=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=> ~~{{ CFA-II (2023) EXAM ROUTE ENDED HERE }}~~ <=-<=-<=-<=-<=-<=-<=-<=-<=-<=-<=-<=-<=-*//

  //* -=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=> ~~{{ CFA-II (2025) EXAM ROUTE START HERE }}~~ <=-<=-<=-<=-<=-<=-<=-<=-<=-<=-<=-<=-<=-*//
  CFA2_2025_DASHBOARD: '/cfa2/2026/dashboard',

  //?  NOTES ROUTE START HERE
  CFA2_2025_NOTES: '/cfa2/2026/notes',
  CFA2_2025_NOTES_READINGS: '/cfa2/2026/notesreadings/:chapter',
  CFA2_2025_NOTES_QUES_VIEW: '/cfa2/2026/notesviewques/:chapter_no/:id/:reading',
  CFA2_2025_BEGIN_NOTES: '/cfa2/2026/beginnotes/:notesid/:readingid/:id/:offset',
  // CFA2_2025_BEGIN_NOTES: '/cfa2/2026/beginnotes(/:notesid)(/:readingid)(/:id)(/:offset)',

  //?  VIDEOS ROUTE START HERE
  CFA2_2025_VIDEO_DISPLAY: '/cfa2/2026/videodisplay/:id/:showFreePremium/:type/:chapter_id/:index',
  CFA2_2025_VIDEO_LESSONS: '/cfa2/2026/videolessons',
  // 2026 videos render the SHARED VideosComponent/VideosListing under the /cfa2/2026 prefix (same
  // prefix-aware pattern as 2027 — see common/cfa2NextRoutes.js). /videos still works for direct hits.
  CFA2_2026_VIDEOS: '/cfa2/2026/videos',
  CFA2_2026_VIDEOS_LIST: '/cfa2/2026/video/list/:chapterId/:id',

  //?  QUESTION BANK ROUTE START HERE
  CFA2_2025_QUESTION_BANK: '/cfa2/2026/questionbank',
  CFA2_2025_QUESTION_BANK_CASES: '/cfa2/2026/cases/:id/:chapter_name/:total_cases',
  CFA2_2025_QUESTION_BANK_CASES_QUESTION:
    '/cfa2/2026/chapter/:chapterid/:caseid/:case_offset/:question_number/:offset',

  //? QUIZ ROUTE START HERE
  CFA2_2025_QUIZZES: '/cfa2/2026/quizzes',
  CFA2_2025_QUIZZES_BEFORE_START: '/cfa2/2026/beforestart(/:quiz_id)(/:status_send)',
  CFA2_2025_QUIZZES_BEGIN: '/cfa2/2026/beginquiz(/:quiz_id)(/:offset)',

  //* -=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=> ~~{{ CFA-II (2025) EXAM ROUTE ENDED HERE }}~~ <=-<=-<=-<=-<=-<=-<=-<=-<=-<=-<=-<=-<=-*//

  //* -=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=> ~~{{ CFA-II (2027) EXAM ROUTE START HERE }}~~ <=-<=-<=-<=-<=-<=-<=-<=-<=-<=-<=-<=-<=-*//
  //* Additive, employee-only preview edition. Independent tree at /cfa2/2027/*; examUrlResolver forces the
  //* cfa_2_2027 token on this prefix, and the routes render the cloned CFA2-2027 views (hitting /cfa_2_2027* +
  //* /cfa2CBTMockExams2027 + /cfa_2_2027quizes). Unlike 2025, CBT lives under /cfa2/2027/* too (not bare /cfa2/).
  CFA2_2027_DASHBOARD: '/cfa2/2027/dashboard',
  CFA2_2027_NOTES: '/cfa2/2027/notes',
  CFA2_2027_NOTES_READINGS: '/cfa2/2027/notesreadings/:chapter',
  CFA2_2027_NOTES_QUES_VIEW: '/cfa2/2027/notesviewques/:chapter_no/:id/:reading',
  CFA2_2027_BEGIN_NOTES: '/cfa2/2027/beginnotes/:notesid/:readingid/:id/:offset',
  CFA2_2027_VIDEO_DISPLAY: '/cfa2/2027/videodisplay/:id/:showFreePremium/:type/:chapter_id/:index',
  CFA2_2027_VIDEO_LESSONS: '/cfa2/2027/videolessons',
  CFA2_2027_QUESTION_BANK: '/cfa2/2027/questionbank',
  CFA2_2027_QUESTION_BANK_CASES: '/cfa2/2027/cases/:id/:chapter_name/:total_cases',
  CFA2_2027_QUESTION_BANK_CASES_QUESTION:
    '/cfa2/2027/chapter/:chapterid/:caseid/:case_offset/:question_number/:offset',
  CFA2_2027_QUIZZES: '/cfa2/2027/quizzes',
  CFA2_2027_QUIZZES_BEFORE_START: '/cfa2/2027/beforestart(/:quiz_id)(/:status_send)',
  CFA2_2027_QUIZZES_BEGIN: '/cfa2/2027/beginquiz(/:quiz_id)(/:offset)',
  CFA2_2027_CBT: '/cfa2/2027/cbt',
  CFA2_2027_CBT_INTRODUCTION: '/cfa2/2027/introduction/:id/:questiono/:timer',
  CFA2_2027_CBT_VIEW_ATTEMPTED_MOCK: '/cfa2/2027/viewattemptedmock/:id/:timer',
  CFA2_2027_CBT_QUESTIONS:
    '/cfa2/2027/cbtquestions/:id/:caseno/:questiono/:timer/:testid/:caseOffset/:quesOffset/:isNegative/:timerStart',
  CFA2_2027_CBT_QUESTIONS_FINISH:
    '/cfa2/2027/cbtquestionsfinish/:id/:caseno/:questiono/:testid/:caseOffset/:quesOffset/:timer',
  CFA2_2027_DETAILED_RESULT_GRAPH:
    '/cfa2/2027/cbtshowresult/:id/:test_id/:totalQuestions/:timer/:isNegative',
  // Videos: the 2027 tree renders the SHARED VideosComponent/VideosListing (edition-neutral
  // /exams/cfa/videos/* endpoints, resolved to cfa2_2027_videos by token) but under the /cfa2/2027
  // prefix. The shared components are prefix-aware (see views/Videos/*), defaulting to /videos.
  CFA2_2027_VIDEOS: '/cfa2/2027/videos',
  CFA2_2027_VIDEOS_LIST: '/cfa2/2027/video/list/:chapterId/:id',
  //* -=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=> ~~{{ CFA-II (2027) EXAM ROUTE ENDED HERE }}~~ <=-<=-<=-<=-<=-<=-<=-<=-<=-<=-<=-<=-<=-*//

  //* -=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=> ~~{{ CFA-III (2023) EXAM ROUTE START HERE }}~~ <=-<=-<=-<=-<=-<=-<=-<=-<=-<=-<=-<=-<=-*//
  CFA3_DASHBOARD: '/cfa3/dashboard',

  //?  NOTES ROUTE START HERE
  CFA3_NOTES: '/cfa3/notes',

  //?  VIDEOS ROUTE START HERE
  CFA3_VIDEO_LESSONS: '/cfa3_videolessons',
  CFA3_VIDEO_DISPLAY: '/cfa3_video_display/:id/:showFreePremium/:type/:chapter_id/:index',

  //?  QUESTION BANK ROUTE START HERE
  CFA3_QUESTION_BANK: '/cfa3/questionBank',

  //? ESSAY QUESTION BANK ROUTE START HERE
  CFA3_ESSAY_QUESTION: '/cfa3/essay-question',
  CFA3_ESSAY_QUESTION_CASES: '/cfa3/essay-question/cases/:chapterID/:chapterName',
  CFA3_ESSAY_QUESTION_CHAPTERS: '/cfa3/essay-question/chapters',
  CFA3_ESSAY_QUESTION_CASE_VIEW:
    '/cfa3/essay-question/case-view/:caseId/:chapterID/:chapterName/:questionIndex/:caseIndex',

  //? QUIZ ROUTE START HERE
  CFA3_QUIZZES: '/cfa3/quizzes',

  //? CBT ROUTE START HERE
  CFA3_CBT: '/cfa3/cbt',
  CFA3_CBT_QUESTIONS:
    '/cfa3/cbt/questions/:id/:caseno/:questiono/:timer/:testid/:caseOffset/:quesOffset/:isNegative/:timerStart',
  CFA3_CBT_QUESTIONS_FINISH:
    '/cfa3/cbt/questionsfinish/:id/:caseno/:questiono/:testid/:caseOffset/:quesOffset/:timer',
  CFA3_CBT_INTRODUCTION: '/cfa3/cbt/introduction/:id/:questiono/:timer',
  CFA3_CBT_DETAILED_RESULT_GRAPH:
    '/cfa3/cbt/showresult/:id/:test_id/:totalQuestions/:totalMarks/:timer/:isNegative',
  CFA3_CBT_VIEW_ATTEMPTED_MOCK: '/cfa3/cbt/viewattemptedmock/:id/:timer',
  CFA3_CBT_GRADE_QUESTIONS:
    '/cfa3/cbt/gradeQuestions/:id/:caseno/:questiono/:timer/:testid/:caseOffset/:quesOffset/:isNegative/:timerStart',

  //? CBT ROUTE START HERE
  CFA3_PATHWAY_CBT: '/pathway',
  CFA3_PATHWAY_SESSION: '/cfa3/pathway/:pathway/session',
  CFA3_PATHWAY_CBT_VIEW_ATTEMPTED_MOCK:
    '/cfa3/pathway/:pathway/session/:session/attempted_mock/:timer',
  CFA3_PATHWAY_CBT_INTRODUCTION:
    '/cfa3/pathway/:pathway/session/:session/introduction/:questiono/:timer',
  CFA3_PATHWAY_CBT_QUESTIONS:
    '/cfa3/pathway/:pathway/session/:session/questions/:caseno/:questiono/:timer/:testid/:caseOffset/:quesOffset/:isNegative/:timerStart',
  CFA3_PATHWAY_CBT_QUESTIONS_FINISH:
    '/cfa3/pathway/finish/:caseno/:questiono/:testid/:caseOffset/:quesOffset/:timer',
  CFA3_PATHWAY_CBT_DETAILED_RESULT_GRAPH:
    '/cfa3/pathway/result/:test_id/:totalQuestions/:totalMarks/:timer/:isNegative',
  CFA3_PATHWAY_CBT_GRADE_QUESTIONS:
    '/cfa3/pathway/grade_questions/:caseno/:questiono/:timer/:testid/:caseOffset/:quesOffset/:isNegative/:timerStart',
  CFA3_2025_QUESTION_BANK_READING_LIST: 'cfa3/cases/:id/:chapter_name/:total_cases',

  //* -=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=> ~~{{ CFA-III (2023) EXAM ROUTE ENDED HERE }}~~ <=-<=-<=-<=-<=-<=-<=-<=-<=-<=-<=-<=-<=-*//

  //* -=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=> ~~{{ ESG EXAM ROUTE START HERE }}~~ <=-<=-<=-<=-<=-<=-<=-<=-<=-<=-<=-<=-<=-*//
  ESG_DASHBOARD: '/esg/dashboard',

  //? NOTES ROUTE START HERE
  ESG_NOTES: '/esg/notes',

  //? Video ROUTE START HERE
  ESG_VIDEOS: '/esg/videos',
  ESG_VIDEO_LESSON: '/esg/videos/chapters/:chapter/:index',

  //? QUESTION BANK ROUTE START HERE
  ESG_QUESTION_BANK: '/esg/question-bank/chapter',
  ESG_QUESTION_BANK_VIEW_QUE: '/esg/question-bank/chapter/:chapterId/question/:id/index/:index',
  ESG_QUESTION_BANK_LIST_QUE: '/esg/question-bank/chapter/:listId/questions',

  //?  QUIZ ROUTE START HERE
  ESG_QUIZZES: '/esg/quizzes',

  //?  CBT ROUTE START HERE
  ESG_CBT: '/esg/cbt',
  ESG_CBT_INTRODUCTION: '/esg/cbt/mock/:id/duration/:timer/introduction/index/:offset',
  ESG_CBT_VIEW_ATTEMPTED_MOCK: '/esg/cbt/mock/:id/duration/:timer/attempted-mock',
  ESG_CBT_DETAILED_STATS_GRAPH:
    '/esg/cbt/mock/:id/test/:testId/duration/:timer/showresult/total-questions/:totalQuestions/total-marks/:totalMarks',
  ESG_CBT_FINISH_PAGE:
    '/esg/cbt/mock/:mockId/test/:testId/duration/:timer/finish-test/question/:questionId/index/:offset',
  ESG_CBT_QUESTIONS:
    '/esg/cbt/mock/:mockId/test/:testId/duration/:timer/question/:questionId/negative-start/:isNegative/index/:offset',
  //* -=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=> ~~{{ ESG EXAM ROUTE ENDED HERE }}~~ <=-<=-<=-<=-<=-<=-<=-<=-<=-<=-<=-<=-<=-*//
  /*
  //!==============================================================================================================================================================
                                               {{ CFA EXAM ENDED HERE }} 
  //!==============================================================================================================================================================
  */

  /*
  //!==============================================================================================================================================================
                                               {{ FRM EXAM STARTED HERE }} 
  //!==============================================================================================================================================================
  */
  //* -=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=> ~~{{ FRM EXAM ROUTE START HERE }}~~ <=-<=-<=-<=-<=-<=-<=-<=-<=-<=-<=-<=-<=-*//
  FRM_DASHBOARD: '/frm/dashboard',

  //? NOTES ROUTE START HERE
  FRM_NOTES: '/frm/notes',

  //? VIDEOS ROUTE START HERE
  // FRM_VIDEO_LESSONS: '/frmvideoLessons',
  FRM_VIDEO_LESSONS: '/frm/videoLessons',

  //? QUESTION BANK ROUTE START HERE
  FRM_QUESTION_BANK: '/frm/questionbank',

  //?  QUIZ ROUTE START HERE
  FRM_QUIZZES: '/frm/quiz',

  //?  CBT ROUTE START HERE
  FRM_CBT: '/frm/cbt',
  FRM_DETAILED_RESULT_GRAPH: '/frm/cbtshowresult/:id/:test_id/:totalQuestions/:level/:timer',

  FRM_V2_QUESTION_BANK: '/frm/v2/question-bank',
  FRM_V2_QUESTION_BANK_READING_LIST:
    '/frm/v2/question-bank/level/:level/chapter/:chapterId/reading-list',
  FRM_V2_QUESTION_BANK_QUESTION_LIST:
    '/frm/v2/question-bank/level/:level/reading/:readingId/question-list',
  FRM_V2_QUESTION_BANK_QUESTION_VIEW:
    '/frm/v2/question-bank/level/:level/reading/:readingId/question/:questionId/view',
  // TODO: Make this route common for FRM exams.
  FRM_QUESTION_BANK_VIEW_QUESTION: '/frm/chapter/:notesid/:readingid/:id/:level/:offset',
  FRM_V2_NOTES: '/frm/v2/notes',
  FRM_V2_NOTES_READING_LIST: '/frm/v2/notes/level/:level/chapter/:chapterId/reading-list',
  FRM_V2_NOTES_VIEW:
    '/frm/v2/notes/level/:level/chapter/:chapterId/reading/:readingId/notes/:notesId/view',

  FRM_V2_DASHBOARD: '/frm/v2/dashboard',
  FRM_V2_DETAILS_STATS_LEVEL1: '/frm/viewallquestions',
  FRM_V2_DETAILS_STATS_LEVEL2: '/frm/2/viewallquestions',

  FRM_VIDEOS: '/frm/v2/videos',
  FRM_V2_VIDEOS_PLAYLIST: '/frm/v2/videos/playlist/level/:level/chapter/:chapterId/:id',
  FRM_V2_VIDEOS_MOCK_PLAYLIST: '/frm/v2/videos/playlist/level/:level/mock/:mockId/:id',
  FRM_V2_CBT_FINISH_PAGE: '/frm/cbtquestionsfinish/:id/:questiono/:timer/:level/:testid/:offset',
  //* -=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=> ~~{{ FRM EXAM ROUTE ENDED HERE }}~~ <=-<=-<=-<=-<=-<=-<=-<=-<=-<=-<=-<=-<=-*//

  /*
  //!==============================================================================================================================================================
                                               {{ FRM EXAM ENDED HERE }} 
   //!==============================================================================================================================================================
  */

  /*
  //!==============================================================================================================================================================
                                                {{ ACTUARIAL EXAM STARTED HERE }} 
  //!==============================================================================================================================================================
  */
  //* -=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=> ~~{{ ACTUARIAL EXAM ROUTE START HERE }}~~ <=-<=-<=-<=-<=-<=-<=-<=-<=-<=-<=-<=-<=-*//
  SOA_PROBABILITY_DASHBOARD: '/soa/probability/dashboard',

  //? NOTES ROUTE START HERE
  SOA_PROBABILITY_NOTES: '/soa/probability/notes',
  SOA_PROBABILITY_NOTES_READING: '/soa/probability/notesreadings(/:chapter)',

  //? VIDEOS ROUTE START HERE
  SOA_PROBABILITY_VIDEO_LESSONS: '/soa/probability/video-lessons',
  SOA_PROBABILITY_VIDEO_DISPLAY:
    '/soa/probability/video-display/:id/:showFreePremium/:chapterId/:index',

  //? QUESTION BANK ROUTE START HERE
  SOA_PROBABILITY_READING: '/soa/probability/readings(/:chapter)(/:chapterName)',
  SOA_PROBABILITY_QUESTION_BANK: '/soa/probability/questionbank',

  //?  QUIZ ROUTE START HERE
  SOA_PROBABILITY_QUIZZES: '/soa/probability/quizzes',

  //* -=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=> ~~{{ ACTUARIAL EXAM ROUTE ENDED HERE }}~~ <=-<=-<=-<=-<=-<=-<=-<=-<=-<=-<=-<=-<=-*//

  //* -=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=> ~~{{ FINANCIAL MATHEMATICS EXAM ROUTE START HERE }}~~ <=-<=-<=-<=-<=-<=-<=-<=-<=-<=-<=-<=-<=-*//
  SOA_FINANCIAL_MATHMATICS_DASHBOARD: '/soa/financialmathematics/dashboard',

  //? NOTES ROUTE START HERE
  SOA_FINANCIAL_MATHMATICS_NOTES: '/soa/financialmathematics/notes',

  //? VIDEOS ROUTE START HERE
  SOA_FINANCIAL_MATHMATICS_VIDEO_LESSONS: '/soa/financialmathematics/videolessons',

  //? QUESTION BANK ROUTE START HERE
  SOA_FINANCIAL_MATHMATICS_QUESTION_BANK: '/soa/financialmathematics/questionbank',

  //?  QUIZ ROUTE START HERE
  SOA_FINANCIAL_MATHMATICS_QUIZZES: '/soa/financialmathematics/quizzes',

  //* -=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=> ~~{{ FINANCIAL MATHEMATICS EXAM ROUTE ENDED HERE }}~~ <=-<=-<=-<=-<=-<=-<=-<=-<=-<=-<=-<=-<=-*//

  /*
  //!==============================================================================================================================================================
                                               {{ ACTUARIAL EXAM ENDED HERE }} 
   //!==============================================================================================================================================================
  */

  /*
  //!==============================================================================================================================================================
                                                {{ MBA ADMISSION STARTED HERE }} 
  //!==============================================================================================================================================================
  */
  //* -=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=> ~~{{ GMAT ROUTE START HERE }}~~ <=-<=-<=-<=-<=-<=-<=-<=-<=-<=-<=-<=-<=-*//
  GMAT_DASHBOARD: '/gmat_dashboard',

  //? VIDEOS ROUTE START HERE
  GMAT_VIDEO_DISPLAY: '/gmatvideodisplay/:id/:showFreePremium/:type/:chapter_id/:index',
  GMAT_VIDEO_LESSONS: '/gmatvideolessons',

  //? QUESTION BANK ROUTE START HERE
  GMAT_QUESTION_BANK: '/gmat_questionbank',
  GMAT_QUESTION_BANK_READING: '/gmat_readings/:id',
  GMAT_QUESTION_BANK_LIST_QUE: '/gmat_viewquestions/:chapter_no/:id/:subscriptionstatus/:reading',
  GMAT_QUESTION_BANK_VIEW_QUE: '/gmat_beginchapter/:notesid/:readingid/:id/:offset',
  GMAT_BEGINCASE:
    '/gmat_begincase/:chapterid/:readingid/:caseid/:case_offset/:subscription/:question_number/:offset',
  GMAT_TAB: '/GMATTab/:chapterid/:readingid/:subscription/:question_id/:offset/:reading',
  GMAT_GRAPH_MULTI_STATEMENT:
    '/GMATMultipleStatement/:chapterid/:readingid/:subscription/:question_id/:offset/:reading',
  GMAT_TABLE: '/GMATTable/:chapterid/:readingid/:subscription/:question_id/:offset/:reading',
  GMAT_TWO_PART_STATEMENT:
    '/GMAT2Statement/:chapterid/:readingid/:subscription/:question_id/:offset/:reading',
  PRACTICE_EXAM: '/practice_exam',

  //?  QUIZ ROUTE START HERE
  GMAT_QUIZZES: '/gmat_quiz',
  GMAT_QUIZZES_BEFORE_START: '/gmat_beforestart/:quiz_id/:status_send',
  GMAT_QUIZZES_BEGIN: '/gmat_beginquiz_tab/:quiz_id/:offset/:type/:timer',
  BEGIN_QUIZ: '/gmat_beginquiz/:quiz_id/:offset/:timer',
  BEGIN_CASE_QUIZ: '/gmat_beginquiz_case/:quiz_id/:offset/:type/:case/:timer',
  BEGIN_TABLE_QUIZ: '/gmat_beginquiz_table/:quiz_id/:offset/:type/:timer',
  BEGIN_GRAPH_QUIZ: '/gmat_beginquiz_graph/:quiz_id/:offset/:type/:timer',
  BEGIN_TWOPART_QUIZ: '/gmat_beginquiz_twopart/:quiz_id/:offset/:type/:timer',
  //* -=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=> ~~{{ GMAT ROUTE ENDED HERE }}~~ <=-<=-<=-<=-<=-<=-<=-<=-<=-<=-<=-<=-<=-*//

  //* -=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=> ~~{{ EXECUTIVE ASSESSMENT ROUTE START HERE }}~~ <=-<=-<=-<=-<=-<=-<=-<=-<=-<=-<=-<=-<=-*//
  EA_DASHBOARD: '/ea_dashboard',

  //? VIDEOS ROUTE START HERE
  EA_VIDEO_DISPLAY: '/eavideodisplay/:id/:showFreePremium/:type/:chapter_id/:index',
  EA_VIDEO_LESSONS: '/eavideolessons',

  //? QUESTION BANK ROUTE START HERE
  EA_BEFORE_START: '/ea_beforestart/:quiz_id/:status_send',
  EA_BEGIN_QUIZ: '/ea_beginquiz/:quiz_id/:offset/:type/:timer',
  EA_BEGIN_CASE_QUIZ: '/ea_beginquiz_case/:quiz_id/:offset/:type/:case/:timer',
  EA_BEGIN_TAB_QUIZ: '/ea_beginquiz_tab/:quiz_id/:offset/:type/:timer',
  EA_BEGIN_TABLE_QUIZ: '/ea_beginquiz_table/:quiz_id/:offset/:type/:timer',
  EA_BEGIN_GRAPH_QUIZ: '/ea_beginquiz_graph/:quiz_id/:offset/:type/:timer',
  EA_BEGIN_TWOPART_QUIZ: '/ea_beginquiz_twopart/:quiz_id/:offset/:type/:timer',
  EA_QUESTION_BANK: '/ea_questionbank',
  VIEW_EA_QUESTION: '/ea_viewquestions/:chapter_no/:id/:subscriptionstatus/:reading',
  EA_READING: '/ea_readings/:id',
  EA_BEGINCHAPTER: '/ea_beginchapter/:notesid/:readingid/:id/:offset',
  EA_BEGINCASE:
    '/ea_begincase/:chapterid/:readingid/:caseid/:case_offset/:subscription/:question_number/:offset',
  EA_TAB: '/EATab/:chapterid/:readingid/:subscription/:question_id/:offset/:reading',
  EA_GRAPH_MULTI_STATEMENT:
    '/EAMultipleStatement/:chapterid/:readingid/:subscription/:question_id/:offset/:reading',
  EA_TABLE: '/EATable/:chapterid/:readingid/:subscription/:question_id/:offset/:reading',
  EA_TWO_PART_STATEMENT:
    '/EA2Statement/:chapterid/:readingid/:subscription/:question_id/:offset/:reading',

  //?  QUIZ ROUTE START HERE
  EA_QUIZZES: '/ea_quiz',

  //* -=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=>-=> ~~{{ EXECUTIVE ASSESSMENT ROUTE ENDED HERE }}~~ <=-<=-<=-<=-<=-<=-<=-<=-<=-<=-<=-<=-<=-*//

  /*
  //!==============================================================================================================================================================
                                               {{ MBA ADMISSION ENDED HERE }} 
   //!==============================================================================================================================================================
  */

  /*
  //!==============================================================================================================================================================
                                               {{ EXPIRED ROUTE EXAM STARTED HERE }} 
   //!==============================================================================================================================================================
  */

  //DASHBOARD
  DASHBOARD: '/dashboard',
  CFA_2022_DASHBOARD: '/cfa1/dashboard_2022',
  CFA2_DASHBOARD: '/cfa2_dashboard',
  SOAIFM_DASHBOARD: '/soa/investmentmarkets/dashboard',

  //NOTES
  NOTES: '/cfanotes',
  NOTES_2022: '/cfa1/cfa_2022_notes',
  NOTES_READINGS_2022: '/cfa1/notesreadings_2022/:chapter',
  NOTES_VIEW_QUES_2022: '/cfa1/notesviewques_2022/:id/:reading/:chapter_no',
  NOTES_BEGIN_2022: '/cfa1/beginnotes_2022/:notesid/:readingid/:id/:offset',
  SOAIFM_NOTES: '/soa/investmentmarkets/notes',
  CFA3_NOTES_READINGS: '/cfa3_notes_readings/:chapter',
  CFA3_NOTES_VIEWQUES: '/cfa3_notes_viewques/:chapter_no/:id/:reading',
  CFA3_BEGIN_NOTES: '/cfa3_beginnotes/:notesid/:readingid/:id/:offset',
  CFA2_BEGIN_NOTES: '/cfa2_beginnotes/:notesid/:id/:offset',
  CFA2NOTESVIEWQUES: '/cfa2notesviewques/:chapter_no/:id/:reading',
  CFA2Notes: '/cfa2_notes',
  CFA2BEGINNOTES: '/cfa2beginnotes/:notesid/:readingid/:id/:offset',
  CFA2NOTESREADINGS: '/cfa2notesreadings/:chapter',

  // VIDEO
  CFA2VIDEODISPLAY: '/cfa2videodisplay/:id/:showFreePremium/:type/:chapter_id/:index',
  CFA2_VIDEODISPLAY: '/cfa2videodisplay/:id/:showFreePremium/:type/:chapter_id/:index',
  VIDEO_DISPLAY_2022: '/cfavideodisplay_2022/:id/:showFreePremium/:type/:chapter_id/:index',
  VIDEO_LESSONS: '/cfavideolessons',
  VIDEO_LESSONS_2022: '/cfavideolessons_2022',
  FLOW_PLAYER_VIDEO_LESSONS_2022: '/cfa1/new_cfavideolessons_2022',
  FLOW_PLAYER_VIDEO_DISPLAY_2022:
    '/cfa1/new_cfavideodisplay_2022/:id/:showFreePremium/:type/:chapter_id/:index',
  CFA2_VIDEO_LESSONS: '/cfa2_videolessons',

  //QUESTIONBANK
  QUESTION_BANK: '/questionbank',
  QUESTION_BANK_2022: '/cfa1/questionbank_2022',
  VIEW_QUESTION_2022: '/cfa1/viewquestions_2022/:chapter_no/:id/:subscriptionstatus/:reading',
  READING_2022: '/cfa1/readings_2022/:id',
  BEGINCHAPTER_2022: '/cfa1/beginchapter_2022/:notesid/:readingid/:id/:offset',
  CFA2_QUESTION_BANK: '/cfa2_questionBank',
  CFA2_QUESTION_BANK_2022: '/cfa2/questionBank_2022',
  SOAIFM_QUESTION_BANK: '/soa/investmentmarkets/questionbank',
  CFA2_CASES: '/cfa2_cases/:id/:chapter_name/:total_cases',

  //QUIZZES
  QUIZZES: '/cfa1/quizzes',
  CFA2_QUIZZES: '/cfa2/quizzes',
  SOAIFM_QUIZZES: '/soa/investmentmarkets/quizzes',

  //CBT
  CBT: '/cfa1/cfacbt',
  Tutor: '/tutor',
  SUBSCRIBE: '/subscribe',
  CFADETAILEDRESULTGRAPH: '/cfa1/cbtshowresult/:id/:test_id/:totalQuestions/:timer',

  RECURRING_PLAN_DETAILS: '/recurring-plan-detail(/:selectedMenu)(/:username)',
  SUBSCRIPTION_DETAILS: '/subscriptiondetail(/:selectedMenu)(/:username)',
  CFA3_DASHBOARD_2025: '/cfa3/2025/dashboard',
  /*
  //!==============================================================================================================================================================
                                               {{ EXPIRED ROUTE EXAM ENDED HERE }} 
   //!==============================================================================================================================================================
  */

  //*----- COMMON ROUTE ----------
  VIDEOS: '/videos',
  VIDEOS_LIST: '/videos/list/:chapterId/:id',
};
export default AppRoutes;



// WEBPACK FOOTER //
// ./src/views/config/AppRoutes.js